var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconThumbsDownFillComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-thumbs_down_fill").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M6.3177 10.2715L6.3177 12.6011C6.3177 13.282 6.67957 13.8779 7.22065 14.2056 7.74635 14.5239 8.34219 14.2131 8.59149 13.6497L11.0001 9.14966 11 1.8164C11 1.72436 10.9253 1.64974 10.8333 1.64974L3.78074 1.64974C3.16116 1.6427 2.6311 2.09528 2.53819 2.71064L1.68083 8.6695C1.62612 9.03155 1.73246 9.39944 1.97169 9.67579 2.21088 9.95211 2.55886 10.109 2.92338 10.1048H6.15103C6.24308 10.1048 6.3177 10.1794 6.3177 10.2715zM12.1669 9.17198C12.0748 9.17198 12.0002 9.09736 12.0002 9.00532L12.0001 1.81688C12.0001 1.72485 12.0747 1.65023 12.1667 1.65021L13.2637 1.64988C13.9691 1.63712 14.5722 2.1668 14.6667 2.88228V7.87133C14.5722 8.5868 13.9691 9.18475 13.2637 9.17198H12.1669z", fillOpacity: "1" }));
}
var IconThumbsDownFill = React.forwardRef(IconThumbsDownFillComponent);
export default IconThumbsDownFill;
